import { MatExpansionPanel } from '@angular/material/expansion';
import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { TutorialService } from 'src/app/core/tutorial/tutorial.service';

@Directive({
    selector: '[tutorialExpansionTarget]'
})
export class TutorialExpansionTargetDirective implements OnInit {
    @Input('tutorialExpansionTarget') targetId!: string;

    constructor(
        private tutorialService: TutorialService,
        private expansionPanel: MatExpansionPanel
    ) { }

    ngOnInit() {
        if (this.targetId) {

            //this.tutorialService.registerExpansionTarget(this.targetId, this.expansionPanel);
        }
    }
}